import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './index.scss';
import $ from 'jquery';


class PostCard extends Component {

  render() {
    const{ linkTo, hashId, title, article ,uuid } = this.props;

    return (
      <div className="post-card">
        <a href={linkTo || `/post/${uuid}`|| `#`}>
          <span>{hashId}</span>
          <span>{title}</span>
          <p className="card-border-line" dangerouslySetInnerHTML={{__html:article}}></p>
          <span>read more</span>
        </a>
      </div>

    );
  }
}
PostCard.propTypes = {
  uuid: PropTypes.string
}


export default PostCard;



// WEBPACK FOOTER //
// ./src/components/PostCard/pure.js